import { render, staticRenderFns } from "./TransportInfoEdit.vue?vue&type=template&id=b36609ec&"
import script from "./TransportInfoEdit.vue?vue&type=script&lang=js&"
export * from "./TransportInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports